<div class="modal-header">
    <h5 class="modal-title">{{title}}</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
  </div>
  <div class="modal-body">
    @if(message){
      <p [innerHTML]="message"></p>
    } @else {
      <p>{{ 'Are you sure?' }}</p>
    }

    @if(actionType === "profileName"){
      <div class="profile-name-fields">
        <label for="profile-first-name">{{ firstNameLabel }}</label>
        <input
          id="profile-first-name"
          type="text"
          class="form-control"
          [(ngModel)]="firstName"
          (ngModelChange)="showRequiredError = false"
        />

        <label for="profile-last-name">{{ lastNameLabel }}</label>
        <input
          id="profile-last-name"
          type="text"
          class="form-control"
          [(ngModel)]="lastName"
          (ngModelChange)="showRequiredError = false"
        />

        @if(showRequiredError){
          <p class="name-error">{{ requiredErrorText }}</p>
        }
      </div>
    }
    
  </div>
  <div class="modal-footer">
    @if(actionType !== "info"){
      <button type="button" [disabled]="isDeleting || isResetting" class="btn btn-secondary" (click)="activeModal.dismiss()">{{ cancelButtonText }}</button>
    }
    @if(actionType === "resetQuestionnaire"){
      <button type="button" [disabled]="isDeleting" class="btn btn-danger" (click)="resetDonorQuestionnaire()">
        @if(isResetting){
            <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
        }
        
        Reset</button>
    } @else if(actionType === "deleteAppointment") {
      <button type="button" [disabled]="isDeleting" class="btn btn-danger" (click)="deleteAppointment()">
        @if(isDeleting){
            <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
        }
        
        Delete</button>
    } @else if(actionType === "confirm") {
      <button type="button" class="btn btn-primary" (click)="confirm()">
        {{ confirmButtonText }}
      </button>
    } @else if(actionType === "info") {
      <button type="button" class="btn btn-primary" (click)="activeModal.close()">
        {{ closeButtonText }}
      </button>
    } @else if(actionType === "profileName") {
      <button type="button" class="btn btn-primary" (click)="submitProfileName()">
        {{ confirmButtonText }}
      </button>
    }
    

  </div>
